import React from 'react';
import cx from 'classnames';

// constellation
import { IconChevronDown, IconChevronUp, Text } from '@zillow/constellation';

// styles
import { StyledMenuLabel } from './style';

interface Props {
  onClick(e: React.SyntheticEvent): void;
  title?: string;
  children?: React.ReactNode;
  isOpen?: boolean;
}

const MenuLabel = ({ isOpen, onClick, children, title = '' }: Props) => {
  return (
    <StyledMenuLabel
      className={cx('MenuLabel', {
        'MenuLabel-open': isOpen,
      })}
      onClick={onClick}
    >
      <Text fontType="body" className="MenuLabel-text" title={title}>
        {children || title}
      </Text>
      <div className="MenuLabel-icon">{isOpen ? <IconChevronUp /> : <IconChevronDown />}</div>
    </StyledMenuLabel>
  );
};

const MenuLabelWithRole = Object.assign(MenuLabel, { role: 'menuLabel' });
export default MenuLabelWithRole;
